import {createContext, useContext, useState, ReactNode} from 'react';

interface CheckoutIssuingContextType {
  isCheckoutIssuing: boolean;
  setIsCheckoutIssuing: (value: boolean) => void;
}

const CheckoutIssuingContext = createContext<CheckoutIssuingContextType | undefined>(undefined);

export function CheckoutIssuingProvider(props: {children: ReactNode}) {
  const [isCheckoutIssuing, setIsCheckoutIssuing] = useState(false);

  return (
    <CheckoutIssuingContext.Provider value={{isCheckoutIssuing, setIsCheckoutIssuing}}>
      {props.children}
    </CheckoutIssuingContext.Provider>
  );
}

export function useCheckoutIssuing() {
  const context = useContext(CheckoutIssuingContext);
  if (!context) {
    throw new Error('useCheckoutIssuing must be used within CheckoutIssuingProvider');
  }
  return context;
}
